import {
  Loadboard,
  PostToLoadboardCommand,
  PostToLoadboardResponse,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment-spec';

export class ShipmentSpecLoadboardController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getAll(shipmentSpecId: number): Promise<Loadboard[]> {
    const response = await this.http.get<Loadboard[]>(
      `${shipmentSpecId}/loadboard/active`,
    );
    return response.data.map((item) => new Loadboard(item));
  }

  async post(
    shipmentSpecId: number,
    command: PostToLoadboardCommand,
  ): Promise<PostToLoadboardResponse[]> {
    const response = await this.http.post<PostToLoadboardResponse[]>(
      `${shipmentSpecId}/loadboard/post`,
      command,
    );
    return response.data.map((item) => new PostToLoadboardResponse(item));
  }

  async remove(shipmentSpecId: number, loadboardId: number): Promise<void> {
    await this.http.delete(`${shipmentSpecId}/loadboard/${loadboardId}`);
  }

  async forceRemove(
    shipmentSpecId: number,
    loadboardId: number,
  ): Promise<void> {
    await this.http.delete(`${shipmentSpecId}/loadboard/${loadboardId}/force`);
  }
}
